// Export without redux connection
import HomePage from "./HomePage";

export default HomePage;
